import { action, makeObservable, observable } from 'mobx';
import { hiLoData, mainData, moreData } from '../helpers/supporters';
import { updatedMarkets } from '../helpers';

class MarketsStore {
  allMarkets = [];

  mainMarketsData = [];

  moreMarketsData = [];

  hiLoMarketsData = [];

  replayActiveMainMoreSection = null;

  replayActiveHILoSection = null;

  hiOrLoMarket = [];

  latestMarkets = [];

  cardHiLoMarket = [];

  replayMinBetValue = null;

  activeButton = true;

  selectedMarket = {
    hiOrLo: null,
  };

  constructor() {
    makeObservable(this, {
      activeButton: observable,
      allMarkets: observable.deep,
      mainMarketsData: observable.deep,
      moreMarketsData: observable.deep,
      hiLoMarketsData: observable.deep,
      cardHiLoMarket: observable.deep,
      latestMarkets: observable.deep,
      hiOrLoMarket: observable.deep,
      selectedMarket: observable.deep,
      replayMinBetValue: observable,
      replayActiveMainMoreSection: observable,
      replayActiveHILoSection: observable,
      setActiveButton: action.bound,
      setSelectedMarket: action.bound,
      setLatestMarkets: action.bound,
      setHiOrLoMarket: action.bound,
      setCardHiLoMarket: action.bound,
      setReplayMinBetValue: action.bound,
      setReplayActiveMainMoreSection: action.bound,
      setReplayActiveHILoSection: action.bound,
      setupMarketsDataByType: action.bound,
    });
  }

  setupMarketsDataByType(allMarkets) {
    this.allMarkets = updatedMarkets(allMarkets);
    this.mainMarketsData = mainData(allMarkets);
    this.moreMarketsData = moreData(allMarkets);
    this.hiLoMarketsData = hiLoData(allMarkets);
  }

  setReplayMinBetValue(minBet) {
    this.replayMinBetValue = minBet;
  }

  setActiveButton(activeButton) {
    this.activeButton = activeButton;
  }

  setReplayActiveMainMoreSection(sectionIndex) {
    this.replayActiveMainMoreSection = sectionIndex;
  }

  setReplayActiveHILoSection(hiOrLo) {
    this.replayActiveHILoSection = hiOrLo;
  }

  setSelectedMarket(selectedMarket) {
    if (this.selectedMarket.marketType === selectedMarket.marketType) {
      this.selectedMarket = {
        hiOrLo: null,
      };
    } else {
      this.selectedMarket = selectedMarket;
    }
  }

  setLatestMarkets(latestMarkets) {
    this.latestMarkets = latestMarkets;
  }

  setHiOrLoMarket(hiOrLoMarket) {
    this.hiOrLoMarket = hiOrLoMarket;
  }

  setCardHiLoMarket(cardHiLoMarket) {
    this.cardHiLoMarket = cardHiLoMarket;
  }
}

export const marketsStore = new MarketsStore();
